import { useEffect, useState } from 'react';
import { TableTitleBox, LoadingSkeleton } from '../../common/components';
import InvoiceQueryFilters from './components/InvoiceQueryFilters';
import InvoiceQueryDataTable from './components/InvoiceQueryDataTable';
import { useInvoiceQuery } from './hooks/useInvoiceQuery';
import { useSalePoints } from '../../hooks/useSalePoints';

const InvoiceQueryTable = () => {
  const { data: salePoints = [], isLoading: loadingSalePoints } = useSalePoints();
  const [salePoint, setSalePoint] = useState('');
  const [voucherNumber, setVoucherNumber] = useState('');
  const [searchParams, setSearchParams] = useState(null);

  const { data, isLoading, error } = useInvoiceQuery(searchParams || {}, {
    enabled: !!searchParams,
  });

  let errorMsg = '';
  if (error) {
    if (error.response && error.response.data && error.response.data.error) {
      errorMsg = error.response.data.error;
    } else if (error.message) {
      errorMsg = error.message;
    } else {
      errorMsg = 'Error desconocido';
    }
  }
  useEffect(() => {
    setSalePoint('');
    setVoucherNumber('');
    setSearchParams(null);
  }, []);

  const handleSearch = () => {
    console.log({ salePointNumber: salePoint, voucherNumber });
    setSearchParams({ salePointNumber: salePoint, voucherNumber });
  };

  return (
    <>
      <TableTitleBox title="Habitat 99 | Registar | Ver factura ARCA" />
      <InvoiceQueryFilters
        salePoints={salePoints}
        salePoint={salePoint}
        setSalePoint={setSalePoint}
        voucherNumber={voucherNumber}
        setVoucherNumber={setVoucherNumber}
        onSearch={handleSearch}
        isLoading={isLoading || loadingSalePoints}
      />
      {errorMsg && (
        <div
          style={{
            color: '#d32f2f',
            fontWeight: 500,
            maxHeight: '40px',
            backgroundColor: 'white',
            marginBottom: 0,
            padding: '8px 16px',
          }}
        >
          {errorMsg}
        </div>
      )}
      <InvoiceQueryDataTable data={data} isLoading={isLoading} LoadingComponent={LoadingSkeleton} />
    </>
  );
};

export default InvoiceQueryTable;
